/**
 * Converts base64 string to Uint8Array with optimization for large files.
 * For files larger than 1MB, processes data in chunks to avoid blocking the main thread.
 */
export const base64ToBytes = async (base64: string): Promise<Uint8Array> => {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);

  // Use more efficient approach for larger files
  if (binaryString.length > 1024 * 1024) {
    // 1MB threshold
    // For large files, process in chunks to avoid blocking the main thread
    const chunkSize = 64 * 1024; // 64KB chunks
    for (let i = 0; i < binaryString.length; i += chunkSize) {
      const end = Math.min(i + chunkSize, binaryString.length);
      for (let j = i; j < end; j++) {
        bytes[j] = binaryString.charCodeAt(j);
      }
      // Allow other tasks to run between chunks
      if (i + chunkSize < binaryString.length) {
        await new Promise((resolve) => setTimeout(resolve, 0));
      }
    }
  } else {
    // For smaller files, keep the simple approach
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
  }
  return bytes;
};
